<template>
    <div>
        <v-card class="ma-4 py-3 px-5" style="background-color: #5D327C; color: #ffffff;">
            <p class="pt-3 pb-0 px-2">Company Snapshot</p>
            <v-card class="mb-3">
                <v-card-text>
                    <v-row>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-select outlined :items="goalOptions" label="Primary goal" v-model="clientDetails.primaryGoal"></v-select>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-select outlined :items="goalOptions" label="Secondary goal" v-model="clientDetails.secondaryGoal"></v-select>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-select outlined :items="typeOptions" label="Client type" v-model="clientDetails.type"></v-select>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field outlined type="text" label="Location" v-model="clientDetails.location"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field outlined type="number" label="Branch count" v-model="clientDetails.branchCount"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field outlined type="number" label="Renter count" v-model="clientDetails.numberOfRenters"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field outlined type="number" label="Property count" v-model="clientDetails.propertyCount"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field outlined type="number" label="Landlord count" v-model="clientDetails.landlordCount"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field outlined type="number" label="Average rent (£)" v-model="clientDetails.averageRent"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field outlined type="number" label="Management fee (£)" v-model="clientDetails.propertyManagementCharge"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-select outlined :items="userManagementProcessOptions" label="Add user process" v-model="clientDetails.addUserProcess"></v-select>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-select outlined :items="userManagementProcessOptions" label="Remove user process" v-model="clientDetails.removeUserProcess"></v-select>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-select outlined :items="userTypeOptions" label="User types" v-model="clientDetails.userTypes"></v-select>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field outlined disabled label="Contract started" v-model="clientDetails.contractReceivedReal"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field outlined label="Contract length" type="number" v-model="clientDetails.contractLength"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-textarea outlined label="Any other business" v-model="clientDetails.aob"></v-textarea>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-btn elevation="0" @click="updateDetails" color="primary" block class="button-style mt-3"> 
                                Update Information
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-card>
    </div>
</template>
<script>
import moment from 'moment'
import { VueEditor } from 'vue2-editor'
export default {
    name: 'CompanyDetails',
    data(){
        return {
            id: this.$route.params.id,
            goalOptions: [
                'Attract landlords',
                'Attract tenants',
                'Retain tenants',
                'Engage with their customers',
                'Enhance their brand',
                'Stand out',
                'Generate customer insights',
                'Generate Revenue',
                'Upsell a package',
                'Help sell their service'
            ],
            typeOptions: [
                'Independent LA',
                'Large Group LA',
                'Single Franchise LA',
                'Franchise Network LA',
                'Property Manager',
                'Private Landlord',
                'HMO Landlord',
                'Rent-to-rent',
                'Block Management',
                'Build-to-rent',
                'Student Accommodation',
                'Housing Association',
                'Unique Partner'
            ],
            userManagementProcessOptions: [
                'Weekly Spreadsheet',
                'Monthly Spreadsheet',
                'Ad Hoc Spreadheet',
                'Manual Entry',
                'API'
            ],
            userTypeOptions: [
                'Giving Basic',
                'Giving Premium', 
                'Giving Both'
            ],
            clientDetails: {},


            // clientCompleted: {
            //     propertyMaintenaceOnPlatform: false, // need checkbox
            //     Website content - Sent from us & On their website (tick boxes)
            //     Social media posts - Facebook, LinkedIn, Twitter, Instagram (tick boxes)
            // }
        }
    },
    methods: {
        getClient(){
            firebase.firestore().collection('clients').doc(this.id).onSnapshot(docSnapshot => {
                this.clientDetails = docSnapshot.data()
                this.clientDetails.contractReceivedReal = moment(Number(this.clientDetails.contractReceived)).format('ll')
                if(!this.clientDetails.userID){
                    this.clientDetails.userID = 0
                }


        // FOR DATA RESTRUCTURE _ DELETE WHEN DONE
                    this.clientDetails.primaryGoal = this.clientDetails.primaryGoal || '',
                    this.clientDetails.secondaryGoal = this.clientDetails.secondaryGoal || '',
                    this.clientDetails.type = this.clientDetails.type || '',
                    this.clientDetails.branchCount = this.clientDetails.branchCount || 0,
                    this.clientDetails.propertyCount = this.clientDetails.propertyCount || 0,
                    this.clientDetails.landlordCount = this.clientDetails.landlordCount || 0,
                    this.clientDetails.averageRent = this.clientDetails.averageRent || 0,
                    this.clientDetails.propertyManagementCharge = this.clientDetails.propertyManagementCharge || 0,
                    this.clientDetails.addUserProcess = this.clientDetails.addUserProcess || '',
                    this.clientDetails.removeUserProcess = this.clientDetails.removeUserProcess || '',
                    this.clientDetails.propertyMaintenanceTool = this.clientDetails.propertyMaintenanceTool || '',
                    this.clientDetails.userTypes = this.clientDetails.userTypes || '',
                    this.clientDetails.aob = this.clientDetails.aob || '',
                    this.clientDetails.contractLength = this.clientDetails.contractLength || 12

        // DELETE ABOVE



            }, err => { console.log(`Encountered error: ${err}`) })
        },
        updateDetails(){
            firebase.firestore().collection('clients').doc(this.id).update(this.clientDetails)
        }
    },
    mounted(){
        this.getClient()
    }
}
</script>
<style>
</style>